// src/components/LoadingLogo.jsx
import React, { useEffect, useState } from 'react';
import './LoadingLogo.css';
import rotatingLogo from '../assets/rotating-logo.png';
import { useTranslation } from 'react-i18next';

export default function LoadingLogo() {
  const { t } = useTranslation();
  const [countdown, setCountdown] = useState(10);

  useEffect(() => {
    const blocks = document.querySelectorAll('.loading-logo-block');
    const randomHeight = (min = 0.3, max = 2.0) =>
      Math.random() * (max - min) + min;

    const animateBlocks = () => {
      blocks.forEach(block => {
        block.style.height = `${randomHeight()}em`;
      });
    };

    const intervalAnim = setInterval(animateBlocks, 500);
    animateBlocks();

    const intervalCountdown = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(intervalCountdown);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => {
      clearInterval(intervalAnim);
      clearInterval(intervalCountdown);
    };
  }, []);

  return (
    <div className="loading-logo-wrapper" role="status" aria-live="polite">
      <div className="loading-logo-icon-wrapper">
        <img
          className="loading-logo-rotating"
          src={rotatingLogo}
          alt="Rotating Logo"
        />
        <div className="loading-logo-bars">
          <div className="loading-logo-column">
            <div className="loading-logo-block loading-logo-green" />
            <div className="loading-logo-block loading-logo-green" />
          </div>
          <div className="loading-logo-column">
            <div className="loading-logo-block loading-logo-green" />
            <div className="loading-logo-block loading-logo-green" />
          </div>
          <div className="loading-logo-column">
            <div className="loading-logo-block loading-logo-blue" />
            <div className="loading-logo-block loading-logo-blue" />
          </div>
        </div>
      </div>
      <p className="loading-logo-text">
        {t("loadingDashboardIn", { seconds: countdown })}
      </p>
    </div>
  );
}
